import React from "react";

const Searchbar = ({setState}) => {
  return (
    <div className="search-container">
      <input type="text" placeholder="Search" />
      <button onClick={()=> setState(true)}>
        <i className="bi bi-plus-lg"></i> Add Google Pixel
      </button>
    </div>
  );
};

export default Searchbar;
